<template>
    <!-- 帮助详情 -->
    <div class="help_details section-hero">
        <div class="container row">
            <div class="col-lg-3 show">
                <div class="row_box" v-for="(value, index) in sidebar" :key="value.id">
                    <card shadow class="shadow-lg--hover" :class="{ 'active': value.id == inx, 'mt-4': index }">
                        <div class="d-flex">
                            <div>
                                <img :src="value.icon" width="50" alt="">
                            </div>
                            <div class="d-flex px-1">
                                <div class="">
                                    <h6 class="title " :class="{ 'text-success': value.id == id }">{{ value.title }}
                                    </h6>
                                    <p style="font-size: 12px;"> {{ value.subtitle }} </p>
                                </div>
                            </div>
                        </div>
                    </card>
                </div>
            </div>

            <div class="col-lg-9 row_content">
                <div class="hidden">
                    <div class="hidden_box"></div>
                </div>
                <div class="col-lg-12 row">
                    <div class="col-lg-3 mt-5" v-for="(value, index) in imgs" :key="index">
                        <img :src="value" class="img-fluid" alt="">
                    </div>
                </div>
                <div class="col-lg-12 row mt-5 show">
                    <div class="col-lg-3 row_content_box" v-for="(value, index) in content" :key="index">
                        <div class="text-center">{{ value }}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="hidden nav_box">
            <div class="nav_box_div">
                <base-button class="btn-1" :type="value.id == id ? 'success' : ''" v-for="value in sidebar"
                    :key="value.id" @click="handleClickSelect(value.id)">{{ value.title
                    }}</base-button>
            </div>
        </div>
    </div>
</template>
<script>

export default {
    name: 'helpDetails',
    props: {
        inx: {
            type: String | Number,
            default: "1"
        },
    },
    data() {
        return {
            id: this.$route.params.id,
            imgs: [],
            title: this.$t('nav.home'),
            maps: new Map([
                ['1', [
                    '/img/pay/1--1.png',
                    '/img/pay/1--2.png',
                    '/img/pay/1--3.png',
                    '/img/pay/1--4.png',
                ]],
                ['2', [
                    '/img/pay/2--1.png',
                    '/img/pay/2--2.png',
                    '/img/pay/2--3.png',
                    '/img/pay/2--4.png',
                ]],
                ['3', [
                    '/img/pay/3--1.png',
                    '/img/pay/3--2.png',
                    '/img/pay/3--3.png',
                    '/img/pay/3--4.png',
                ]],
                ['4', [
                    '/img/pay/4--1.png',
                    '/img/pay/4--2.png',
                    '/img/pay/4--3.png',
                    '/img/pay/4--4.png',

                ]],
            ])
        }
    },

    computed: {
        sidebar() {
            return [
                {
                    id: '1',
                    title: this.$t('help.title1'),
                    subtitle: this.$t('help.desc1'),
                    icon: '/img/pay/0--21.png',
                },
                {
                    id: '2',
                    title: this.$t('help.title2'),
                    subtitle: this.$t('help.desc2'),
                    icon: '/img/pay/0-_icon-13.png',
                },
                {
                    id: '3',
                    title: this.$t('help.title3'),
                    subtitle: this.$t('help.desc3'),
                    icon: '/img/pay/0-_icon-14.png',
                },
                {
                    id: '4',
                    title: this.$t('help.title4'),
                    subtitle: this.$t('help.desc4'),
                    icon: '/img/pay/0-_icon-17.png',
                },
            ];
        },
        content() {
            if (this.inx == 1)
                return this.$t('help.step').split(",");
            else if (this.inx == 2)
                return this.$t('help.step2').split(",");
            else if (this.inx == 3)
                return this.$t('help.step3').split(",");
            else
                return this.$t('help.step4').split(",");
        }
    },
    created() {
        console.log(this.inx)
        if (this.inx) {
            this.imgs = this.maps.get(this.inx);
        }
    },
    methods: {
        handleClickSelect(id) {
            this.id = id;
            this.imgs = this.maps.get(this.id);
            // 回到顶部
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    },
}
</script>
<style scoped lang="scss">
/* 显示/隐藏类 */
.show {
    // display: block;
}

.hidden {
    display: none;

    .hidden_box {
        width: 100%;
        height: 80px;
    }
}

.nav_box {
    position: fixed;
    z-index: 11;
    top: 67px;
    width: 100%;

    .nav_box_div {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 20px;
        background-color: white;
        height: 80px;
    }
}

.row_box {
    ::v-deep .card-body {
        padding: 20px 10px !important;
    }
}

/* 响应式设计 */
@media (max-width: 992px) {
    .show {
        display: none;
    }

    .hidden {
        display: block;
    }

    .container.row {
        flex-direction: column;
    }

    .col-lg-9.row_content {
        margin-top: 30px;
        align-items: center;
    }
}

.help_details {
    background-image: url('/img/pay/0-_BG-3.png');
    background-size: cover;
    background-position: bottom;
    background-repeat: no-repeat;
    height: var(--main-height);
    display: flex;
    justify-content: center;
    // padding-top: 68px;
}

.container {
    // height: var(--main-height);
    height: 100%;

    &.row {
        // height: var(--main-height);
        // height: 100%;
        align-items: center;
        justify-content: space-between;
    }



    .row_box {
        background-color: white;
        box-shadow: 0 15px 35px rgba(50, 50, 93, 0.1), 0 5px 15px rgba(0, 0, 0, 0.07) !important;
        border-radius: 0.25rem;
        cursor: pointer;
    }

    .row_content {
        // justify-content: flex-end;
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .row_content_box {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .row_content_box::after {
        content: '';
        position: absolute;
        right: 0;
        // bottom: 0;
        width: 10px;
        height: 10px;
        border-top: 10px solid green;
        border-right: 10px solid green;
        border-bottom: 10px solid transparent;
        border-left: 10px solid transparent;
        background-color: transparent;
        transform: rotateZ(45deg);
    }

    .row_content_box:last-child::after {
        content: '';
        height: 0;
        width: 0;
        border: 0;
    }

    .active {
        transform: translateX(50px);
    }
}
</style>
